import styled from 'styled-components';

export const CartBody = styled.div<{ $centered?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ $centered }) => ($centered ? 'center' : 'flex-start')};
  gap: 12px;
  padding: 16px 8px;
  flex: 1;
  background: var(--v3-black-1);
  overflow: auto;
`;
